var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 0h24v24H0V0Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0090FF",
    d: "M12 24C5.4 24 0 18.6 0 11.94.06 5.34 5.4-.06 12.06 0 18.66.06 24 5.4 24 12.12 23.94 18.66 18.6 24 12 24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.14 10.56-.36 1.92 3.42.48-.24.9-3.36-.48c-.24.78-.36 1.62-.66 2.34-.3.84-.6 1.68-.96 2.46-.48 1.02-1.32 1.74-2.46 1.92-.66.12-1.38.06-1.92-.36-.18-.12-.36-.36-.36-.54 0-.24.12-.54.3-.66.12-.06.42 0 .6.06.18.18.36.42.48.66.36.48.84.54 1.32.18.54-.48.84-1.14 1.02-1.8.36-1.44.72-2.82 1.02-4.26v-.24l-3.18-.48.12-.9 3.3.48.42-1.86-3.42-.54.12-.96 3.54.48c.12-.36.18-.66.3-.96.3-1.08.6-2.16 1.32-3.12.72-.96 1.56-1.56 2.82-1.5.54 0 1.08.18 1.44.6.06.06.18.18.18.3 0 .24 0 .54-.18.72-.24.18-.54.12-.78-.12-.18-.18-.3-.36-.48-.54-.36-.48-.9-.54-1.32-.12-.3.3-.6.72-.78 1.14-.42 1.26-.72 2.58-1.14 3.9l3.3.48-.24.9-3.18-.48Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFil);
export default __webpack_public_path__ + "static/media/fil.a1be6857723d9d95d68d5b7a79924845.svg";
export { ForwardRef as ReactComponent };